<p>
  <button (click)="callGetStation()">callGetStation</button>
</p>
